<template>
  <div class="product">
    <innerBanner :banner="$t('product.banner')" />
    <hotBrandSwiper v-if="brandList.length > 0" :brandList="brandList" />
    <main class="product-main">
      <div class="wp">
        <aside :class="showMenu ? 'show' : ''" class="product-menu">
          <div class="menu-top forMobile">
            <div class="icon"></div>
            <div class="btn" @click="showMenu = false"></div>
          </div>
          <div class="selected-tags">
            <p>
              {{ $t('product.filterTags.choice') }}：{{
                filterTags.length > 0 ? '' : $t('product.filterTags.noChoice')
              }}
            </p>
            <el-tag
              v-for="(tag, index) in filterTags"
              :key="index"
              closable
              type="info"
              @close="closeTag(tag)"
            >
              {{ tag }}
            </el-tag>
          </div>
          <button class="reset-choice" @click="resetChoices">
            {{ $t('product.filterTags.resetChoice') }}
          </button>
          <div class="menu-item">
            <div
              :class="showFilterNav ? 'open' : ''"
              class="menu-tit"
              @click="showFilterNav = !showFilterNav"
            >
              <span>{{ $t('product.filter1') }}</span>
              <i></i>
            </div>
            <nav v-if="showFilterNav">
              <div
                v-for="(item, index) in filterTagList"
                :key="index"
                class="nav-radio"
              >
                <label :class="item.total === 0 ? 'disabled' : ''">
                  <input
                    name="filter"
                    type="checkbox"
                    :value="item._id"
                    v-model="filter.tags"
                    @change="handleChange"
                  />
                  <span class="name">
                    {{ item._id }}
                    <span class="num">({{ item.total }})</span>
                  </span>
                </label>
              </div>
            </nav>
          </div>
          <div class="menu-item">
            <div
              :class="showTypeNav ? 'open' : ''"
              class="menu-tit"
              @click="showTypeNav = !showTypeNav"
            >
              <span>{{ $t('product.filter2') }}</span>
              <i></i>
            </div>
            <nav v-if="showTypeNav">
              <div
                v-for="(item, index) in filterCateList"
                :key="index"
                class="nav-radio"
              >
                <label :class="item.total === 0 ? 'disabled' : ''">
                  <input
                    name="type"
                    type="checkbox"
                    :value="item._id"
                    v-model="filter.cates"
                    @change="handleChange"
                  />
                  <span class="name">
                    {{ item._id }}
                    <span class="num">({{ item.total }})</span>
                  </span>
                </label>
              </div>
            </nav>
          </div>
          <div class="menu-item">
            <div
              :class="showBrandNav ? 'open' : ''"
              class="menu-tit"
              @click="showBrandNav = !showBrandNav"
            >
              <span>{{ $t('product.filter3') }}</span>
              <i></i>
            </div>
            <nav v-if="showBrandNav">
              <div
                v-for="(item, index) in filterBrandList"
                :key="index"
                class="nav-radio"
              >
                <label :class="item.total === 0 ? 'disabled' : ''">
                  <input
                    name="brand"
                    type="checkbox"
                    :value="item._id"
                    v-model="filter.brands"
                    @change="handleChange"
                  />
                  <span class="name">
                    {{ item._id }}
                    <span class="num">({{ item.total }})</span>
                  </span>
                </label>
              </div>
            </nav>
          </div>
        </aside>
        <div class="product-content">
          <div class="product-content-top">
            <!-- <div class="crumb">
							<span>{{ $t('product.showWords') }}</span>
							<em>&gt;</em>
						</div> -->
            <div class="search">
              <div class="show">
                {{ showWords }}
                <div
                  class="filter-icon forMobile"
                  @click="showMenu = true"
                ></div>
              </div>
              <div class="form">
                <i></i>
                <input
                  v-model="keywords"
                  :placeholder="$t('product.placeholder')"
                  type="text"
                  @keyup.enter="search"
                />
              </div>
            </div>
          </div>
          <template v-if="noData">
            <div class="no-data">{{ $t('product.noProduct') }}</div>
          </template>
          <template v-else>
            <div class="goods-list2" v-loading="isLoading">
              <goodsItem
                v-for="(item, index) in lang === 'zh'
                  ? productList
                  : productListEn"
                :key="index"
                :item="item"
              />
            </div>
            <!-- <pagination/> -->
            <div class="page">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currPage"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total"
                :small="isSmall"
              >
              </el-pagination>
            </div>
          </template>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import qs from 'qs'
import innerBanner from '@/components/innerBanner'
import hotBrandSwiper from '@/views/product/modules/hotBrandSwiper'
import goodsItem from '@/components/goodsItem'
import pagination from '@/components/pagination'

export default {
  name: 'product',
  components: {
    innerBanner,
    hotBrandSwiper,
    goodsItem,
    pagination
  },
  data() {
    return {
      offsetTopProd: 0,
      lang: this.$i18n.locale,
      isLoading: true,
      currPage: 1,
      pageSize: 24,
      total: 0,
      isSmall: false,
      brandList: [],
      allFilters: {},
      filterTagList: [],
      filterCateList: [],
      filterBrandList: [],
      filter: {
        tags: [],
        cates: [],
        brands: []
      },
      filterTags: [],
      productList: [],
      productListEn: [],
      showWords: this.$t('product.showWords'),
      showMenu: false,
      keywords: '',
      noData: false,
      // 筛选
      showFilterNav: false,
      // 分类
      showTypeNav: false,
      //品牌
      showBrandNav: false,
      //商品列表
      enFontFamily:
        this.$i18n.locale === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            },
      enBold:
        this.$i18n.locale === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
    }
  },
  created() {
    this.getBrands()
    this.getFilters()
  },
  activated() {
    if (this.$i18n.locale === 'zh') {
      if (this.$route.query.other_tag === '新品上市') {
        this.showFilterNav = true
        this.filter.tags = ['新品上市']
        this.getFilterTags()
      }
    } else {
      if (this.$route.query.tags === 'New Arrivals') {
        this.showFilterNav = true
        this.filter.tags = ['New Arrivals']
        this.getFilterTags()
      }
    }

    if (this.$route.query.brand) {
      this.keywords = this.$route.query.brand
    }
    this.getProducts()
    this.changeBanner()
    this.initListener()
    window.scrollTo(0, this.offsetTopProd || 0)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'productDetail' || to.name === 'brandDetail')
      this.offsetTopProd = document.documentElement.scrollTop
    else this.offsetTopProd = 0
    next()
  },
  deactivated() {
    this.destroyListener()
  },
  methods: {
    async getBrands() {
      const queryInfo = qs.stringify(
        {
          locale: this.lang,
          filters: {
            isHot: { $eq: true }
          },
          pagination: {
            start: 0,
            limit: 20
          },
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(`${this.$strapiUrl}/brands?${queryInfo}`)
      this.brandList = res.map((item) => ({
        brand_name: item.attributes.brand_name,
        slug: item.attributes.slug,
        img: item.attributes.thumbnail.data.attributes.url
      }))
    },
    async getFilters() {
      const { data: res } = await this.$http.get(`${this.$baseUrl}/get-filters`)
      if (res.meta.status !== 200)
        return this.$message.error('获取过滤器列表失败！')
      this.allFilters = res.data
      this.filterTagList = [
        ...(this.$i18n.locale === 'zh'
          ? this.allFilters.tag_cn
          : this.allFilters.tag_en)
      ]
      this.filterCateList = [
        ...(this.$i18n.locale === 'zh'
          ? this.allFilters.cate_cn
          : this.allFilters.cate_en)
      ]
      this.filterBrandList = [
        ...(this.$i18n.locale === 'zh'
          ? this.allFilters.brand_cn
          : this.allFilters.brand_en)
      ]
    },
    async getProducts() {
      this.isLoading = true
      const query = {
        lang: this.lang,
        currPage: this.currPage,
        pageSize: this.pageSize,
        keywords: this.keywords,
        ...this.filter
      }
      const { data: res } = await this.$http.get(
        `${this.$baseUrl}/get-products`,
        {
          params: query,
          paramsSerializer: (params) => qs.stringify(params)
        }
      )
      if (res.meta.status !== 200)
        return this.$message.error('获取商品列表失败！')
      if (res.data.total === 0) this.noData = true
      else this.noData = false
      this.total = res.data.total
      this.productList = res.data.productList.map((item) => ({
        id: item._id,
        img: item.avatarPublicUrl,
        name: item.item_cn,
        brand: item.brand_cn,
        sku: item.sku,
        upc: item.upc,
        sku_box: item.sku_box
      }))
      this.productListEn = res.data.productList.map((item) => ({
        id: item._id,
        img: item.avatarPublicUrl,
        name: item.item_en,
        brand: item.brand_en,
        sku: item.sku,
        upc: item.upc,
        sku_box: item.sku_box
      }))
      this.isLoading = false
    },
    handleChange() {
      this.getFilterTags()
      this.getProducts()
    },
    getFilterTags() {
      this.filterTags = [
        ...this.filter.tags,
        ...this.filter.cates,
        ...this.filter.brands
      ]
    },
    closeTag(tag) {
      this.filter.tags = this.filter.tags.filter((item) => item !== tag)
      this.filter.cates = this.filter.cates.filter((item) => item !== tag)
      this.filter.brands = this.filter.brands.filter((item) => item !== tag)
      this.handleChange()
    },
    search() {
      if (this.keywords) {
        this.showWords = '“' + this.keywords + '”'
        this.getProducts()
      } else {
        this.showWords = this.$t('product.showWords')
        this.getProducts()
      }
    },
    handleCurrentChange(page) {
      this.currPage = page
      this.getProducts()
    },
    initListener() {
      this.$_resizeHandler = this.myDebounce(() => {
        this.changeBanner()
      })
      window.addEventListener('resize', this.$_resizeHandler)
    },
    destroyListener() {
      window.removeEventListener('resize', this.$_resizeHandler)
      this.$_resizeHandler = null
    },
    changeBanner() {
      this.isSmall = window.innerWidth <= 767
    },
    resetChoices() {
      this.filter = {
        tags: [],
        cates: [],
        brands: []
      }
      this.filterTags.length = 0
      this.keywords = ''
      this.getProducts()
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.lang = newValue
      this.getBrands()
      this.showWords = this.$t('product.showWords')
      this.filterTagList = [
        ...(this.lang === 'zh'
          ? this.allFilters.tag_cn
          : this.allFilters.tag_en)
      ]
      this.filterCateList = [
        ...(this.lang === 'zh'
          ? this.allFilters.cate_cn
          : this.allFilters.cate_en)
      ]
      this.filterBrandList = [
        ...(this.lang === 'zh'
          ? this.allFilters.brand_cn
          : this.allFilters.brand_en)
      ]
      this.enFontFamily =
        newValue === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            }
      this.enBold =
        newValue === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
      this.resetChoices()
    }
  }
}
</script>

<style lang="scss" scoped>
//product-main
.product-main {
  padding: 66px 0;

  .wp {
    display: flex;

    .product-menu {
      flex: 0 0 260px;
      margin-right: 40px;
      .selected-tags {
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
      }
      .reset-choice {
        margin: 20px auto 0;
        display: block;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
        border: 1px solid #2a2728;
        border-radius: 100px;
        background-color: transparent;
        padding: 0 10px;
      }

      .menu-item {
        padding: 32px 0;
        border-bottom: 1px solid #dddbcb;

        .menu-tit {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          span {
            @extend .sub1-18px;
          }

          i {
            display: block;
            width: 24px;
            height: 25px;
            background: url('~@/assets/images/add.png') no-repeat center center /
              contain;
          }
        }

        .menu-tit.open i {
          background-image: url(~@/assets/images/redu.png);
        }

        nav {
          padding-top: 32px;

          .nav-radio {
            label {
              display: block;
              position: relative;
              overflow: hidden;
              cursor: pointer;

              input {
                position: absolute;
                left: -99999px;
              }

              .name {
                @extend .regular-16px;
                display: flex;
                align-items: center;
                padding-left: 36px;
                position: relative;

                .num {
                  opacity: 0.5;
                  margin-left: 8px;
                }
              }

              .name:after {
                content: '';
                width: 20px;
                height: 20px;
                background: #ffffff;
                border: 1px solid #dddbcb;
                border-radius: 50%;
                position: absolute;
                left: 0;
                top: 50%;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
              }

              input:checked + .name:after {
                border-color: $black;
                background: url('~@/assets/images/checked.png') no-repeat center
                  center / contain;
              }
            }

            label.disabled {
              pointer-events: none;

              .name {
                color: rgba(42, 39, 40, 0.5);

                .num {
                  color: rgba(42, 39, 40, 0.5);
                  opacity: 1;
                }
              }

              .name:after {
                border-color: rgba(42, 39, 40, 0.5);
              }
            }
          }

          .nav-radio + .nav-radio {
            margin-top: 16px;
          }
        }
      }
    }

    .product-content {
      padding-top: 25px;
      flex: 1;
      .page {
        text-align: center;
      }

      .search {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-top: 8px;

        .show {
          font-size: 24px;
          line-height: 32px;
          font-weight: 600;
        }

        .form {
          flex: 0 0 380px;
          border-radius: 10px;
          height: 40px;
          position: relative;
          overflow: hidden;
          border: 1px solid $black;

          input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border: none;
            background: none;
            padding-left: 50px;
            font-size: 16px;
            padding-right: 20px;
            z-index: 1;
          }

          i {
            position: absolute;
            left: 20px;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            width: 18px;
            height: 18px;
            background: url('~@/assets/images/search.png') no-repeat center
              center / contain;
          }
        }
      }
    }
  }
}

.menu-top {
  display: none;
}

.filter-icon {
  display: none;
}

@media only screen and (max-width: 1199px) {
  .goods-list2 .goods-item {
    flex: 0 0 calc(33.3% - 50px);
  }
}

@media only screen and (max-width: 959px) {
  .product-main .wp .product-menu {
    flex: 0 0 200px;
  }
  .goods-list2 {
    margin: 40px 0 0;
  }
  .goods-list2 .goods-item {
    flex: 0 0 calc(50% - 20px);
    margin: 0 10px 20px;
  }
  .product-main .wp .product-content .search .form {
    flex: 0 0 60%;
  }
}

@media only screen and (max-width: 767px) {
  .product-main {
    padding: 20px 0;
    display: block;
  }
  .product-main .wp {
    display: block;
  }
  .product-main .wp .product-menu {
    position: fixed;
    display: none;
    padding: 0 20px;
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    overflow-y: auto;
    background-color: #fff;
    z-index: 999999;
  }
  .product-main .wp .product-menu.show {
    display: block;
  }
  .product-main .wp .product-menu .menu-item {
    padding: 20px 0;
    margin: 0 57px;
  }
  .product-main .wp .product-menu .menu-item:last-child {
    border-bottom: none;
  }
  .product-main .wp .product-content {
    padding-top: 0;
  }
  .menu-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #dddbcb;

    .icon {
      background: url('~@/assets/images/filter.png') no-repeat center center /
        contain;
      width: 20px;
      height: 21px;
    }

    .btn {
      background: url('~@/assets/images/close.svg') no-repeat center center /
        contain;
      width: 30px;
      height: 30px;
    }
  }
  .product-main .wp .product-content .search {
    display: block;
  }
  .product-main .wp .product-content .search .show {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .filter-icon {
    display: block;
    background: url('~@/assets/images/filter.png') no-repeat center center /
      contain;
    width: 20px;
    height: 21px;
  }
  .product-content-top {
    position: sticky;
    top: 60px;
    left: 0;
    background-color: #fff;
    z-index: 10;
    padding-bottom: 20px;
  }
  .goods-list2 {
    margin-top: 0;
  }
}
</style>
